import React from "react";
import { Box } from "@mui/material";

/** Order status labels that use a leading "Label:" line in section 2. Longest first. */
const ORDER_STATUS_LABELS = [
  "Offer suggested",
  "Offer accepted",
  "Pending payment",
  "Completed",
  "Cancelled",
  "Draft",
  "Paid"
] as const;

/** Bolds only a leading order-status label (e.g. "Cancelled:") in the status list. */
export const renderAboutOrderSopStepBody = (text: string): React.ReactNode => {
  for (const label of ORDER_STATUS_LABELS) {
    const prefix = `${label}:`;
    if (text.startsWith(prefix)) {
      return (
        <>
          <Box component="span" sx={{ fontWeight: 700, color: "text.primary" }}>
            {prefix}
          </Box>{" "}
          {text.slice(prefix.length).trimStart()}
        </>
      );
    }
  }

  return text;
};
